import Common from './Common';

class Provider extends Common {
  constructor() {
    super('/api/v1/leads');
  }
}

const provider = new Provider();

export const {
  save,
} = provider;



// WEBPACK FOOTER //
// ./src/services/providers/leads.js